export default "__VITE_ASSET__JJ$yjqC1__"